import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  font-weight: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { ellipsis } from 'polished';
import styled from 'styled-components';
import { Indicator } from '@scp/ui-shared/components/typography';
import { typography } from '@scp/ui-shared/theme/variables';
import { getValuesToDisplay } from './utils';
var MAX_VALUES_TO_SHOW = 2;
var Text = styled.span(_templateObject(), ellipsis());
var StyledIndicator = styled(Indicator).attrs({
  large: true
})(_templateObject2(), typography.fontWeightSemiBold);
export var Value = function Value(_ref) {
  var _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      _ref$totalCount = _ref.totalCount,
      totalCount = _ref$totalCount === void 0 ? 0 : _ref$totalCount;
  var indicator = values[0].count;
  return React.createElement(React.Fragment, null, React.createElement(Text, null, getValuesToDisplay(values, totalCount, MAX_VALUES_TO_SHOW)), !!indicator && React.createElement(StyledIndicator, null, "(".concat(indicator, ")")));
};